import React from "react";
import { Flame } from "lucide-react";

function MenuCard({ item }) {
  const isVeg = item.dietary?.vegetarian;
  const isDrink = item.menuType === "drinks";
  const isMultiVariant = item.pricing.mode === "variants";

  return (
    <article
      className={`classic-menu-item ${isMultiVariant ? "card-multi-variant" : ""} ${
        isDrink ? "card-drink" : ""
      }`}
    >
      <div className="item-header-line">
        <div className="item-title-box">
          {!isDrink && (
            <span
              className={`dietary-dot ${isVeg ? "veg" : "non-veg"}`}
              title={isVeg ? "Vegetarian" : "Non-Vegetarian"}
              aria-label={isVeg ? "Vegetarian" : "Non-Vegetarian"}
            />
          )}

          {isDrink && item.category && (
            <span className="drink-type-badge">
              {item.category.shortLabel || "SPIRIT"}
            </span>
          )}

          <h4 className="item-name-classic">{item.name.toUpperCase()}</h4>

          {item.badge && <span className="item-mini-badge">{item.badge}</span>}

          {item.spicy && (
            <span
              className="spicy-level"
              title={`${item.spicy} Chilli Spice`}
              aria-label={`Spice level: ${item.spicy}`}
            >
              {[...Array(item.spicy)].map((_, idx) => (
                <Flame key={idx} size={12} className="flame-icon" />
              ))}
            </span>
          )}
        </div>

        {/* Pricing */}
        <div className="item-price-box">
          {item.pricing.mode === "single" && (
            <span className="single-price">₹{item.pricing.amount}</span>
          )}
          {item.pricing.mode === "seasonal" && (
            <span className="seasonal-price">Seasonal</span>
          )}
          {item.pricing.mode === "variants" && (
            <div className="variants-row">
              {item.pricing.options.map((opt) => (
                <span key={opt.label} className="variant-item">
                  <span className="v-label">{opt.label}:</span>{" "}
                  <span className="v-amount">
                    {opt.amount ? `₹${opt.amount}` : "Market"}
                  </span>
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      {item.description && (
        <p className="item-description-classic">{item.description}</p>
      )}
    </article>
  );
}

export default React.memo(MenuCard);
